export const webPortfolio = [
  {
    id: 1,
    title: 'E-lectric Website',
    sourceUrl: 'https://github.com/Hamzaoutdoors/e-lectro-frontend',
    liveUrl: 'https://www.figma.com/design/l36JcXkKYN13F8s5I9X1VN/e-lectro--eCommerce-website-2023-?m=auto&t=gkGV3LZiyWaGcvNN-6',
    img: './assets/projects/electroWeb.webp',
  },
  /*   {
    id: 2,
    title: 'Coffee Shop App',
    sourceUrl:
    'https://github.com/Hamzaoutdoors/CoffeeJunkie',
    liveUrl: 'https://hamzaoutdoors-coffeejunkie.netlify.app/',
    img: 'https://i.ibb.co/j3jRYPt/Blackboard-International-Day-of-Education-Greeting-Card-1.png',
  }, */
  {
    id: 2,
    title: 'Rental Cars App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/rentalcars_frontend',
    liveUrl: 'https://hanjelscars.netlify.app/',
    img: './assets/projects/rentWeb.webp',
  },
  {
    id: 3,
    title: 'Space Travelers Hub',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Space-Travelers-Hub',
    liveUrl: 'https://space-traveler-hub-hl.netlify.app/',
    img: './assets/projects/swarakhWeb.webp',
  },
  {
    id: 4,
    title: 'Code & Outdoors website',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Code_Outdoors_Meetings',
    liveUrl: 'https://hamzaoutdoors.github.io/Code_Outdoors_Meetings/',
    img: './assets/projects/codingWeb.webp',
  },
  {
    id: 5,
    title: 'Series lovers App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Serie_Lovers---JS-Capstone-',
    liveUrl: 'https://hamzaoutdoors.github.io/Serie_Lovers---JS-Capstone-/',
    img: './assets/projects/moviesWeb.webp',
  },
];

export const mobilePortfolio = [
/*   {
    id: 1,
    title: 'Covid19 Tracker App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Corona-Tracker__react-capstone',
    liveUrl: 'https://ho-coronatracker21.netlify.app/',
    img:
        'https://i.ibb.co/wLH7Ph1/5.png',
  }, */
  {
    id: 1,
    title: 'R3 Logistics App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/R3_front',
    liveUrl: 'https://www.figma.com/design/5Cgv8gI7Y5b8ToCPL3EASq/R3-Logistic--1--Copy-?m=auto&t=gkGV3LZiyWaGcvNN-6',
    img:
        './assets/projects/r3Mobile.webp',
  },
  {
    id: 2,
    title: 'Rental Cars App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/rentalcars_frontend',
    liveUrl: 'https://hanjelscars.netlify.app/',
    img: './assets/projects/rentMobile.webp',
  },
  {
    id: 3,
    title: 'My Blog App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/Blog_app',
    liveUrl: 'https://hanjelscars.netlify.app/',
    img:
        './assets/projects/blocAppmobile.webp',
  },
  {
    id: 4,
    title: 'Bouygues Telecom',
    sourceUrl: '',
    liveUrl: 'https://www.assistance.bouyguestelecom.fr/s/application-mobile-espace-client',
    img:
        './assets/projects/bytelMobile.webp',
  },
  {
    id: 5,
    title: 'NeoKraal Ecosystem App',
    sourceUrl: 'https://github.com/Hamzaoutdoors/NeoKraal-App/tree/androidv2',
    liveUrl: 'https://www.figma.com/design/MfrlSS8YtB4GaRG3LSRvYt/NeoKraal-Market-Place?m=auto&t=jPnEsT7nhpEgNq1L-6',
    img:
        './assets/projects/neoKMobile.webp',
  },
];

export const credentials = [
  {
    id: 1,
    title: 'HTML5/CSS3',
    credentialUrl: 'https://www.credential.net/b55b54c2-3ba8-4264-8ee6-625dcd529878',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/htmlcss-cred.webp',
  },
  {
    id: 2,
    title: 'JavaScript ES6',
    credentialUrl: 'https://www.credential.net/792d39b5-29ed-473c-830e-0193daf24663',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/js-cred.webp',
  },
  {
    id: 3,
    title: 'ReactJS & Redux',
    credentialUrl: 'https://www.credential.net/87916e61-5e83-415e-96c1-d6031bd770ad',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/react-cred.webp',
  },
  {
    id: 4,
    title: 'Ruby & DataBases',
    credentialUrl: 'https://www.credential.net/8d1d6c34-7e24-4ed3-8c63-05e4b4080f26',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/ruby-cred.webp',
  },
  {
    id: 5,
    title: 'Ruby on Rails',
    credentialUrl: 'https://www.credential.net/07054f1d-c771-42d6-b053-33b0604f69b0',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/ror-cred.webp',
  },
  {
    id: 6,
    title: 'Full Stack Diploma',
    credentialUrl: 'https://www.credential.net/4e05c71f-9679-4c8c-b14b-6eef7ac68be4',
    sourceUrl: false,
    liveUrl: false,
    img:
        './assets/certificates/diplomat.webp',
    badgeImg:
        './assets/certificates/badge.webp',
    fullStack: true,
  },
];
